module.exports = __webpack_public_path__ + "static/media/envelope-white.8f07e6d8.svg";